import { TranslateService } from "@ngx-translate/core";
import { Injectable } from "@angular/core";

export const configs = {
  bufferTime: 600,
  subresourcetypes: [], // Future you can add which all subresource type doesnt need to be retriggered
  responses: [{
    code: 1,
    display: 'Data sent to entity tree'
  },
  {
    code: 2,
    display: 'Update to entity tree done'
  },
    {
      code: 3,
      display: 'No modified data to update'
    },
    {
      code: 4,
      display: 'Unable to update patient details'
    }]
};

export enum CONFIGBINDING_ACTION_TYPES {
  COPY_TO_FORM_DATA = 'COPY_TO_FORM_DATA',
  SET_TO_OPTIONS = 'SET_TO_OPTIONS',
  SET_TO_OPTIONS_RESOURCE = 'SET_TO_OPTIONS_RESOURCE',
  SET_TO_CONFIG = 'SET_TO_CONFIG',
  SET_TO_BINDING_MAP = 'SET_TO_BINDING_MAP'
}

export enum REPLACE_ACTION_TYPES {
  SET_TO_OPTIONS = 'SET_TO_OPTIONS',
  SET_TO_OPTIONS_RESOURCE = 'SET_TO_OPTIONS_RESOURCE',
  SET_TO_IDENTIFIER = 'SET_TO_IDENTIFIER',
  SET_TO_PROPERTY = 'SET_TO_PROPERTY'
}

export enum CONSTANTS  {
  Please_fill_required_fields= "Please fill required fields.",
  Patient_details_updated_successfully = 'Patient details updated successfully!',
  Patient_details_saved_successfully = 'Patient details saved successfully!',
  CLICK_ON_ADD_TO_THE_TABLE = 'Click on + to add the record to the Table.',
  UNABLE_TO_UPDATE_PATIENT_DETAILS = 'Unable to update patient details.',
  THERE_WAS_ERROR_DURING_UPDATE = 'There was error during update',
  NO_MODIFIED_DATA_TO_UPDATE = 'No modified data to update.',
  FILE_DELETED_SUCCESSFULLY = 'File deleted successfully!',
  CANNOT_UPLOAD_FILE = 'Cannot upload file: These extensions are not supported: ',
  CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION= 'Cannot upload file: wrong extension. Expected extension is: ',
  ORDER_CREATED_SUCCESSFULLY = 'Order created successfully!',
  FAILED_TO_CREATE_AN_ORDER = 'Failed to create an Order!',
  ORDER_DELETED_SUCCESSFULLY= 'Order deleted successfully!',
  FAILED_TO_DELETE_ORDER = 'Failed to delete Order!',
  FAILED_TO_UPDATE_ORDER = 'Failed to update order!',
  ORDER_DETAILS_SAVED_SUCCESSFULLY = 'Order Details saved successfully!',
  FAILED_TO_SAVE_ORDER_DETAILS = 'Failed to save Order Details!',
  DATA_SAVED_SUCCESSFULLY= 'Data saved successfully',
  UNABLE_TO_SAVE_DATA = 'Unable to save data.',
  RELOAD_OF_FORM_DEFINITIONS_TRIGGERED_SUCCESSFULLY = 'Reload of form definitions triggered successfully ',
  FAILED_TO_TRIGGER_RELOAD_OF_FORM_DEFINITIONS = 'Failed to trigger reload of form definitions',
  PLEASE_ADD_A = "Please add a",
  NO_MODIFIED_DATA_FOR_STOP_WORKFLOW = 'No modified data for stop workflow',
  STOP_WORKFLOW_SUCCESSFUL = 'Stop workflow successful',
  ERROR_IN_STOP_WORKFLOW = 'Error in stop workflow',
  NO_MODIFIED_DATA_FOR_MANAGING_FACILITY = 'No modified data for managing facility',
  UPDATE_MANAGING_FACILITY_SUCCESSFUL = 'Updating managing facility is successful',
  ERROR_IN_UPDATE_MANAGING_FACILITY = 'Error in updating managing facility',
  UNABLE_TO_UPDATE_PATIENT = 'Unable to update Patient',
  PATIENT_UPDATED_SUCCESSFULLY = 'Patient Updated Successfully!',
  PATIENT_CREATED_SUCCESSFULLY = 'Patient Created Successfully!',
  CONTINUING_WITH_EXISTING_PATIENT = 'Continuing with existing Patient.',
  UNABLE_TO_CREATE_PATIENT = 'Unable to create patient',
  FAILED_TO_CREATE_EVENT = 'Failed to create event!',
  EVENT_DELETED_SUCCESSFULLY = 'Event deleted successfully!',
  FAILED_TO_DELETE_EVENT = 'Failed to delete event!',
  EVENT_CREATED_SUCCESSFULLY = 'Event created successfully!',
  EVENT_APPROVED_SUCCESSFULLY = 'Event approved successfully!',
  EVENT_DATA_UPDATED_SUCCESSFULLY = 'Event data updated successfully!',
  FAILED_TO_UPDATE_EVENT_DATA = 'Failed to update event data!',
  COPIED_EVENT_DATA_TO_RESPECTIVE_SOURCE = 'Copied event data to respective source.',
  FAILED_TO_COPY_EVENT_DATA_TO_RESPECTIVE_SOURCE = 'Failed to copy event data to respective source.',
  EVENT_SELECTED_SUCCESSFULLY = 'Event selected successfully!',
  CANNOT_UPLOAD_FILE_SIZE_EXCEEDS = 'Cannot upload file: size exceeds. Expected size is:',
  CANNOT_UPLOAD_FILE_MAXIMUM_THRESHOLD_REACHED = 'Cannot upload file: maximum file upload threshold reached. Expected count is:',
  FILE_UPLOADED_AND_ATTACHED_SUCCESSFULLY = 'File uploaded and attached successfully!',
  IS_MISSING_IN_CONFIGURATION = 'is missing in configuration.',
  NO_ITEMS_TO_EXPORT = 'No items to export.',
  FAILED_TO_EXPORT_DATA_TO_EXCEL = 'Failed to export data to excel.',
  ASYNC_EXPORT_DATA_TO_EXCEL_STARTED = 'Export in progress and might take few minutes. File will be downloaded once completed.',
  ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL = 'Failed to generate <WORKLIST_NAME> export file.',
  ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL_EXPIRED = 'Failed to generate <WORKLIST_NAME> export file. Please try again or contact support if the problem persists.',
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_TITLE = 'File generation completed',
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BODY = 'File generation was completed. Click here to download the <WORKLIST_NAME> export file.',
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BUTTON = 'Click to Download',
  SOMETHING_WENT_WRONG_WITH_API_CALL = 'Something went wrong with API call',
  NO_ITEMS_SELECTED_FROM_WORKLIST = 'No items selected from worklist.',
  ERROR_IN_CREATING_FILTER = 'Error in creating filter',
  DEFAULT_FILTER_CANNOT_BE_CHANGED = 'Default {{filter}} cannot be changed',
  UPDATED_SUCCESSFULLY = 'updated successfully!',
  FAILED_TO_UPDATE = 'Failed to update',
  DELETED_SUCCESSFULLY = 'deleted successfully!',
  ERROR_DELETING = "Error deleting",
  CREATED_SUCCESSFULLY = 'created successfully!',
  FAILURE_TO_CREATE = 'Failure to create',
  UNABLE_TO_GENERATE_DOCUMENT = 'Unable to generate document',
  UNABLE_TO_SEND_REPORT_TO_EMR = 'Unable to send report to EMR ',
  RESOURCE_NOT_FOUND = 'Resource not found: ',
  ERROR_WHILE_UPDATING = 'Error while updating ',
  CREATED_NEW_TEST_SUCCESSFULLY = 'Item created successfully!',
  ADDENDUM_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR = "Addendum report was scheduled for posting to EMR",
  FAILED_POSTING_ADDENDUM_REPORT_TO_EMR = "Failed posting addendum report to EMR",
  FAILED_POSTING_FINAL_REPORT_TO_EMR = 'Failed posting final report to EMR',
  FINAL_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR = 'Final report was scheduled for posting to EMR',
  UNABLE_TO_SUBMIT_TEST = 'unable to submit test',
  ERROR_WHILE_GETTING_DATA_FOR_PDF_FROM_SERVER = 'Error while getting data for PDF from server',
  ERROR_WHILE_GETTING_DATA_FROM_SERVER = 'Error while getting data from server',
  ERROR_WHILE_SEARCH_FOR_TEST_FROM_WORKLIST = 'error while search for test from worklist',
  SUCCESSFULLY_MOVED_TO_NEXT_STEP = 'Successfully moved to next step',
  UNABLE_TO_MOVE_TO_THE_NEXT_STEP = 'Unable to move to the next step',
  TEST_REMOVED_FROM_YOUR_WORKLIST_SUCCESSFULLY = 'Test removed from your worklist successfully!',
  ERROR_WHILE_REMOVING_TEST_FROM_WORKLIST = 'error while removing test from worklist',
  FAILED_TO_GENERATE_PDF_TEMPLATE_TO_PREVIEW = 'Failed to generate PDF template to preview.',
  CANNOT_PREVIEW_TEMPLATE_WAS_NOT_LOADED_YET = 'Cannot preview: template was not loaded yet.',
  CANNOT_PUBLISH_TEMPLATE_WAS_NOT_LOADED_YET = 'Cannot publish: template was not loaded yet.',
  CANNOT_SAVE_AS_DRAFT_TEMPLATE_WAS_NOT_LOADED_YET = 'Cannot save as draft: template was not loaded yet.',
  EDITED_REPORT_TEMPLATE_DATA_WAS_CANCELLED = 'Edited report template data was cancelled.',
  SUCCESSFULLY_BACK_TO_PREVIOUS_STEP = 'Successfully back to pathway selection step',
  ITEM_REVISED_SUCCESSFULLY = 'Item revised successfully',
  FAILED_BACK_TO_PREVIOUS_STEP = 'Failed back to pathway selection step',
  PATHWAY_NO_TREATMENT_SELECTED = "No treatment was selected",
  PATHWAY_NO_OTHER_REASON_EXTRA_DETAILS = ' No data was entered for off-pathway reasoning',
  PATHWAY_OFF_PATH_NO_REASONING = "No reasoning was selected for Off-Path",
  PATHWAY_NO_COMMENT_WAS_SELECTED = "No data was entered for unlisted clinical trial or treatment plan",
  PATHWAY_NO_OPTION_WAS_SELECTED = "No treatment option was selected",
  ITEM_REVISE_FAILED = 'Item revise failed',
  SUCCESSFULLY_REPORT_GENERATED = 'The report was generated successfully. You can view the report in the patient attachments and in the timeline.',
  NOT_ABLE_TO_FIND_MRN = 'Not able to find MRN',
  NOT_ABLE_TO_FIND_ACCESSION_NUMBER = 'Accession number is missing',
  NOT_ABLE_TO_FIND_TEST_NUMBER = 'Test number is missing',
  NOT_ABLE_TO_FIND_APPLICATION_NAME = 'Application name is missing',
  NOT_ABLE_TO_FIND_SOURCE_EVENT_INFORMATION = 'Source event information is missing',
  SOME_OF_FIELDS_ARE_INVALID = 'Some of the fields are invalid',
  FILE_UPLOAD_FAILED = 'File upload failed',
  SERVER_URL_NOT_CONFIGURED = 'Configure server URL to launch optellum VNC',
  NO_FINDINGS_INFO = 'There are no more findings in this event',
  NLP_RUNNING ='NLP Running. Please wait...',
  NLP_FAILED ='NLP Failed. Retry after sometime...',
  NLP_SUCCEED = 'NLP process Done.',
  CANNOT_GET_TREATMENT_PLANS = 'Cannot receive list of existed treatment plans',
  TRENDS_MAX_SELECTION = 'Reached maximum selection of parameters.',
  EXCEEDS_ACR_EXPORT_LIMIT = 'Reached Maximum Configured Selection for ACR Export:',
  SUCCESSFULLY_MOVED_BACK_TO_WETLAB = 'Successfully moved back to WetLab',
  TEST_SUCCESSFULLY_ABORTED = 'Test successfully aborted',
  ACR_EXPORT_LIMIT_MSG ='Selection exceeds supported number. Export will contain first',
  FILENAME_CONTAINS_HTML = 'Failed to upload file. The following characters are forbidden in the filename: \\ \/ : \* \? " < > \|',
  TAG_CONTAINS_HTML = 'Failed to add tag: Invalid tag name.',
  FILE_TYPE_NOT_ALLOWED = 'Cannot upload file: File type is not allowed.',
  CACHE_CLEARED_SUCCESSFULLY = 'Cached data was cleared successfully',
  FAILED_TO_CLEAR_CACHE = 'Failed to clear cached data'
  }

  /* START - GEN-87502 -------*/

/**
 * ConstInterpolatorService service allows to incorporate parameters into a message constant.
 *
 * The method 'interpolate' receives a message 'constMsg' and list of values to replaces 'replacedValues'.
 *  the convention for in-message's parameters is: '{{default_value}}', where the default_value is used
 *  if no matching message parameter's value is provided.
 *  The full message is then translated, through the TranslateService.
 *
 * IMPORTANT: all message constants with parameters at NOTIFICATION_MESSAGE should be processed as the following:
 *            <MESSAGE>>:inject(ConstInterpolatorService).interpolate(CONSTANTS.<MESSAGE>>).
 *            this implant the default value(s) into the message
 */
@Injectable({ providedIn: 'root'})
export class ConstInterpolatorService {

  constructor(
    private translateService: TranslateService
  ) {

  }

  interpolate(constMsg: string, ...replacedValues: string[]): string {
    // get the full message
    let message: string = constMsg;

    // replace in the message all parameters with the provided substitute string
    // Note: in case that no substitute value is provided, the message will include the default value, which is specified inline
    let startIndex = 0;
    let arrayIndex = 0;
    while (startIndex >= 0) {

      // search a place-holder for the start-parameter's signal
      startIndex = message.indexOf('{{', startIndex);

      if (startIndex < 0) break; // didn't find signal of start-parameter

      // found a signal of start-parameter:

      // find the place-holder for the end-parameter's signal
      let endIndex = message.indexOf('}}', startIndex + 2);

      if (endIndex < 0) break; // didn't find signal of end-parameter

      // found a signal of end-parameter:
      let paramValue;

      // get if a substitute string is provided
      if (arrayIndex < replacedValues.length) {
        paramValue = replacedValues[arrayIndex]; // read the substitute string
        arrayIndex++; // increment the index of next position in the array

      // substitute string is NOT provided
      } else {
        paramValue = message.substring(startIndex + 2, endIndex); // extract the default value which is within the brackets
      }

      // build the new message
      let newMsg = '';
      if (startIndex > 0) {
        newMsg = message.substring(0, startIndex);
      }

      newMsg = newMsg + paramValue;

      endIndex = endIndex + 2;
      if (endIndex < message.length) {
        newMsg = newMsg + message.substring(endIndex);
      }

      message = newMsg;
    }

    return this.translateService.instant(message);
  }
}

/* END - GEN-87502 -------*/

@Injectable({ providedIn: 'root'})
export class NOTIFICATION_MESSAGE {
  constructor(
    private translateService:TranslateService,
    private constInterpolatorService: ConstInterpolatorService
  )
  {
    this.Please_fill_required_fields = this.translateService.instant(CONSTANTS.Please_fill_required_fields);
    this.Patient_details_updated_successfully = this.translateService.instant(CONSTANTS.Patient_details_updated_successfully);
    this.Patient_details_saved_successfully = this.translateService.instant(CONSTANTS.Patient_details_saved_successfully);
    this.CLICK_ON_ADD_TO_THE_TABLE = this.translateService.instant(CONSTANTS.CLICK_ON_ADD_TO_THE_TABLE);
    this.UNABLE_TO_UPDATE_PATIENT_DETAILS = this.translateService.instant(CONSTANTS.UNABLE_TO_UPDATE_PATIENT_DETAILS);
    this.THERE_WAS_ERROR_DURING_UPDATE = this.translateService.instant(CONSTANTS.THERE_WAS_ERROR_DURING_UPDATE);
    this.NO_MODIFIED_DATA_TO_UPDATE = this.translateService.instant(CONSTANTS.NO_MODIFIED_DATA_TO_UPDATE);
    this.FILE_DELETED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.FILE_DELETED_SUCCESSFULLY);
    this.CANNOT_UPLOAD_FILE = this.translateService.instant(CONSTANTS.CANNOT_UPLOAD_FILE);
    this.ORDER_CREATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.ORDER_CREATED_SUCCESSFULLY);
    this.FAILED_TO_CREATE_AN_ORDER = this.translateService.instant(CONSTANTS.FAILED_TO_CREATE_AN_ORDER);
    this.ORDER_DELETED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.ORDER_DELETED_SUCCESSFULLY);
    this.FAILED_TO_DELETE_ORDER = this.translateService.instant(CONSTANTS.FAILED_TO_DELETE_ORDER);
    this.FAILED_TO_UPDATE_ORDER = this.translateService.instant(CONSTANTS.FAILED_TO_UPDATE_ORDER);
    this.ORDER_DETAILS_SAVED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.ORDER_DETAILS_SAVED_SUCCESSFULLY);
    this.FAILED_TO_SAVE_ORDER_DETAILS = this.translateService.instant(CONSTANTS.FAILED_TO_SAVE_ORDER_DETAILS);
    this.DATA_SAVED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.DATA_SAVED_SUCCESSFULLY);
    this.UNABLE_TO_SAVE_DATA = this.translateService.instant(CONSTANTS.UNABLE_TO_SAVE_DATA);
    this.RELOAD_OF_FORM_DEFINITIONS_TRIGGERED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.RELOAD_OF_FORM_DEFINITIONS_TRIGGERED_SUCCESSFULLY);
    this.FAILED_TO_TRIGGER_RELOAD_OF_FORM_DEFINITIONS = this.translateService.instant(CONSTANTS.FAILED_TO_TRIGGER_RELOAD_OF_FORM_DEFINITIONS);
    this.PLEASE_ADD_A = this.translateService.instant(CONSTANTS.PLEASE_ADD_A);
    this.CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION = this.translateService.instant(CONSTANTS.CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION);
    this.NO_MODIFIED_DATA_FOR_STOP_WORKFLOW = this.translateService.instant(CONSTANTS.NO_MODIFIED_DATA_FOR_STOP_WORKFLOW);
    this.STOP_WORKFLOW_SUCCESSFUL = this.translateService.instant(CONSTANTS.STOP_WORKFLOW_SUCCESSFUL);
    this.ERROR_IN_STOP_WORKFLOW = this.translateService.instant(CONSTANTS.ERROR_IN_STOP_WORKFLOW);
    this.NO_MODIFIED_DATA_FOR_MANAGING_FACILITY = this.translateService.instant(CONSTANTS.NO_MODIFIED_DATA_FOR_MANAGING_FACILITY);
    this.UPDATE_MANAGING_FACILITY_SUCCESSFUL = this.translateService.instant(CONSTANTS.UPDATE_MANAGING_FACILITY_SUCCESSFUL);
    this.ERROR_IN_UPDATE_MANAGING_FACILITY = this.translateService.instant(CONSTANTS.ERROR_IN_UPDATE_MANAGING_FACILITY);
    this.UNABLE_TO_UPDATE_PATIENT = this.translateService.instant(CONSTANTS.UNABLE_TO_UPDATE_PATIENT);
    this.PATIENT_UPDATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.PATIENT_UPDATED_SUCCESSFULLY);
    this.PATIENT_CREATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.PATIENT_CREATED_SUCCESSFULLY);
    this.CONTINUING_WITH_EXISTING_PATIENT = this.translateService.instant(CONSTANTS.CONTINUING_WITH_EXISTING_PATIENT);
    this.UNABLE_TO_CREATE_PATIENT = this.translateService.instant(CONSTANTS.UNABLE_TO_CREATE_PATIENT);
    this.FAILED_TO_CREATE_EVENT = this.translateService.instant(CONSTANTS.FAILED_TO_CREATE_EVENT);
    this.EVENT_DELETED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.EVENT_DELETED_SUCCESSFULLY);
    this.FAILED_TO_DELETE_EVENT = this.translateService.instant(CONSTANTS.FAILED_TO_DELETE_EVENT);
    this.EVENT_CREATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.EVENT_CREATED_SUCCESSFULLY);
    this.EVENT_APPROVED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.EVENT_APPROVED_SUCCESSFULLY);
    this.EVENT_DATA_UPDATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.EVENT_DATA_UPDATED_SUCCESSFULLY);
    this.FAILED_TO_UPDATE_EVENT_DATA = this.translateService.instant(CONSTANTS.FAILED_TO_UPDATE_EVENT_DATA);
    this.COPIED_EVENT_DATA_TO_RESPECTIVE_SOURCE = this.translateService.instant(CONSTANTS.COPIED_EVENT_DATA_TO_RESPECTIVE_SOURCE);
    this.FAILED_TO_COPY_EVENT_DATA_TO_RESPECTIVE_SOURCE = this.translateService.instant(CONSTANTS.FAILED_TO_COPY_EVENT_DATA_TO_RESPECTIVE_SOURCE);
    this.EVENT_SELECTED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.EVENT_SELECTED_SUCCESSFULLY);
    this.CANNOT_UPLOAD_FILE_SIZE_EXCEEDS = this.translateService.instant(CONSTANTS.CANNOT_UPLOAD_FILE_SIZE_EXCEEDS);
    this.CANNOT_UPLOAD_FILE_MAXIMUM_THRESHOLD_REACHED = this.translateService.instant(CONSTANTS.CANNOT_UPLOAD_FILE_MAXIMUM_THRESHOLD_REACHED);
    this.FILE_UPLOADED_AND_ATTACHED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.FILE_UPLOADED_AND_ATTACHED_SUCCESSFULLY);
    this.IS_MISSING_IN_CONFIGURATION = this.translateService.instant(CONSTANTS.IS_MISSING_IN_CONFIGURATION);
    this.NO_ITEMS_TO_EXPORT = this.translateService.instant(CONSTANTS.NO_ITEMS_TO_EXPORT);
    this.FAILED_TO_EXPORT_DATA_TO_EXCEL = this.translateService.instant(CONSTANTS.FAILED_TO_EXPORT_DATA_TO_EXCEL);
    this.ASYNC_EXPORT_DATA_TO_EXCEL_STARTED = this.translateService.instant(CONSTANTS.ASYNC_EXPORT_DATA_TO_EXCEL_STARTED);
    this.ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL = this.translateService.instant(CONSTANTS.ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL);
    this.ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL_EXPIRED = this.translateService.instant(CONSTANTS.ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL_EXPIRED);
    this.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_TITLE = this.translateService.instant(CONSTANTS.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_TITLE);
    this.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BODY = this.translateService.instant(CONSTANTS.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BODY);
    this.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BUTTON = this.translateService.instant(CONSTANTS.ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BUTTON);
    this.SOMETHING_WENT_WRONG_WITH_API_CALL = this.translateService.instant(CONSTANTS.SOMETHING_WENT_WRONG_WITH_API_CALL);
    this.NO_ITEMS_SELECTED_FROM_WORKLIST = this.translateService.instant(CONSTANTS.NO_ITEMS_SELECTED_FROM_WORKLIST);
    this.ERROR_IN_CREATING_FILTER = this.translateService.instant(CONSTANTS.ERROR_IN_CREATING_FILTER);
    this.UPDATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.UPDATED_SUCCESSFULLY);
    this.FAILED_TO_UPDATE = this.translateService.instant(CONSTANTS.FAILED_TO_UPDATE);
    this.DELETED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.DELETED_SUCCESSFULLY);
    this.ERROR_DELETING = this.translateService.instant(CONSTANTS.ERROR_DELETING);
    this.CREATED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.CREATED_SUCCESSFULLY);
    this.FAILURE_TO_CREATE = this.translateService.instant(CONSTANTS.FAILURE_TO_CREATE);
    this.UNABLE_TO_GENERATE_DOCUMENT = this.translateService.instant(CONSTANTS.UNABLE_TO_GENERATE_DOCUMENT);
    this.UNABLE_TO_SEND_REPORT_TO_EMR = this.translateService.instant(CONSTANTS.UNABLE_TO_SEND_REPORT_TO_EMR);
    this.RESOURCE_NOT_FOUND = this.translateService.instant(CONSTANTS.RESOURCE_NOT_FOUND);
    this.ERROR_WHILE_UPDATING = this.translateService.instant(CONSTANTS.ERROR_WHILE_UPDATING);
    this.CREATED_NEW_TEST_SUCCESSFULLY = this.translateService.instant(CONSTANTS.CREATED_NEW_TEST_SUCCESSFULLY);
    this.ADDENDUM_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR = this.translateService.instant(CONSTANTS.ADDENDUM_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR);
    this.FAILED_POSTING_ADDENDUM_REPORT_TO_EMR = this.translateService.instant(CONSTANTS.FAILED_POSTING_ADDENDUM_REPORT_TO_EMR);
    this.FAILED_POSTING_FINAL_REPORT_TO_EMR = this.translateService.instant(CONSTANTS.FAILED_POSTING_FINAL_REPORT_TO_EMR);
    this.FINAL_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR = this.translateService.instant(CONSTANTS.FINAL_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR);
    this.UNABLE_TO_SUBMIT_TEST = this.translateService.instant(CONSTANTS.UNABLE_TO_SUBMIT_TEST);
    this.ERROR_WHILE_GETTING_DATA_FOR_PDF_FROM_SERVER = this.translateService.instant(CONSTANTS.ERROR_WHILE_GETTING_DATA_FOR_PDF_FROM_SERVER);
    this.ERROR_WHILE_SEARCH_FOR_TEST_FROM_WORKLIST = this.translateService.instant(CONSTANTS.ERROR_WHILE_SEARCH_FOR_TEST_FROM_WORKLIST);
    this.SUCCESSFULLY_MOVED_TO_NEXT_STEP = this.translateService.instant(CONSTANTS.SUCCESSFULLY_MOVED_TO_NEXT_STEP);
    this.UNABLE_TO_MOVE_TO_THE_NEXT_STEP = this.translateService.instant(CONSTANTS.UNABLE_TO_MOVE_TO_THE_NEXT_STEP);
    this.TEST_REMOVED_FROM_YOUR_WORKLIST_SUCCESSFULLY = this.translateService.instant(CONSTANTS.TEST_REMOVED_FROM_YOUR_WORKLIST_SUCCESSFULLY);
    this.ERROR_WHILE_REMOVING_TEST_FROM_WORKLIST = this.translateService.instant(CONSTANTS.ERROR_WHILE_REMOVING_TEST_FROM_WORKLIST);
    this.FAILED_TO_GENERATE_PDF_TEMPLATE_TO_PREVIEW = this.translateService.instant(CONSTANTS.FAILED_TO_GENERATE_PDF_TEMPLATE_TO_PREVIEW);
    this.CANNOT_PREVIEW_TEMPLATE_WAS_NOT_LOADED_YET = this.translateService.instant(CONSTANTS.CANNOT_PREVIEW_TEMPLATE_WAS_NOT_LOADED_YET);
    this.CANNOT_PUBLISH_TEMPLATE_WAS_NOT_LOADED_YET = this.translateService.instant(CONSTANTS.CANNOT_PUBLISH_TEMPLATE_WAS_NOT_LOADED_YET);
    this.CANNOT_SAVE_AS_DRAFT_TEMPLATE_WAS_NOT_LOADED_YET = this.translateService.instant(CONSTANTS.CANNOT_SAVE_AS_DRAFT_TEMPLATE_WAS_NOT_LOADED_YET);
    this.EDITED_REPORT_TEMPLATE_DATA_WAS_CANCELLED = this.translateService.instant(CONSTANTS.EDITED_REPORT_TEMPLATE_DATA_WAS_CANCELLED);
    this.SUCCESSFULLY_BACK_TO_PREVIOUS_STEP = this.translateService.instant(CONSTANTS.SUCCESSFULLY_BACK_TO_PREVIOUS_STEP);
    this.ITEM_REVISED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.ITEM_REVISED_SUCCESSFULLY);
    this.FAILED_BACK_TO_PREVIOUS_STEP = this.translateService.instant(CONSTANTS.FAILED_BACK_TO_PREVIOUS_STEP);
    this.ITEM_REVISE_FAILED = this.translateService.instant(CONSTANTS.ITEM_REVISE_FAILED);
    this.PATHWAY_NO_TREATMENT_WAS_SELECTED = this.translateService.instant(CONSTANTS.PATHWAY_NO_TREATMENT_SELECTED);
    this.PATHWAY_NO_OTHER_REASON_EXTRA_DETAILS = this.translateService.instant(CONSTANTS.PATHWAY_NO_OTHER_REASON_EXTRA_DETAILS);
    this.PATHWAY_OFF_PATH_NO_REASONING = this.translateService.instant(CONSTANTS.PATHWAY_OFF_PATH_NO_REASONING);
    this.PATHWAY_NO_COMMENT_WAS_SELECTED = this.translateService.instant(CONSTANTS.PATHWAY_NO_COMMENT_WAS_SELECTED);
    this.PATHWAY_NO_OPTION_WAS_SELECTED = this.translateService.instant(CONSTANTS.PATHWAY_NO_OPTION_WAS_SELECTED);
      this.SUCCESSFULLY_REPORT_GENERATED = this.translateService.instant(CONSTANTS.SUCCESSFULLY_REPORT_GENERATED);
      this.NOT_ABLE_TO_FIND_MRN = this.translateService.instant(CONSTANTS.NOT_ABLE_TO_FIND_MRN);
      this.NOT_ABLE_TO_FIND_ACCESSION_NUMBER = this.translateService.instant(CONSTANTS.NOT_ABLE_TO_FIND_ACCESSION_NUMBER);
      this.NOT_ABLE_TO_FIND_TEST_NUMBER = this.translateService.instant(CONSTANTS.NOT_ABLE_TO_FIND_TEST_NUMBER);
      this.NOT_ABLE_TO_FIND_APPLICATION_NAME = this.translateService.instant(CONSTANTS.NOT_ABLE_TO_FIND_APPLICATION_NAME);
      this.NOT_ABLE_TO_FIND_SOURCE_EVENT_INFORMATION = this.translateService.instant(CONSTANTS.NOT_ABLE_TO_FIND_SOURCE_EVENT_INFORMATION);
      this.SERVER_URL_NOT_CONFIGURED = this.translateService.instant(CONSTANTS.SERVER_URL_NOT_CONFIGURED);
      this.SOME_OF_FIELDS_ARE_INVALID = this.translateService.instant(CONSTANTS.SOME_OF_FIELDS_ARE_INVALID);
      this.NO_FINDINGS_INFO = this.translateService.instant(CONSTANTS.NO_FINDINGS_INFO);
      this.FILE_UPLOAD_FAILED = this.translateService.instant(CONSTANTS.FILE_UPLOAD_FAILED);
      // interpolated messages
      this.DEFAULT_FILTER_CANNOT_BE_CHANGED = this.constInterpolatorService.interpolate(CONSTANTS.DEFAULT_FILTER_CANNOT_BE_CHANGED);
      this.ERROR_WHILE_GETTING_DATA_FROM_SERVER = this.constInterpolatorService.interpolate(CONSTANTS.ERROR_WHILE_GETTING_DATA_FROM_SERVER);
      this.NLP_RUNNING = this.constInterpolatorService.interpolate(CONSTANTS.NLP_RUNNING);
      this.NLP_FAILED = this.constInterpolatorService.interpolate(CONSTANTS.NLP_FAILED);
      this.NLP_SUCCEED = this.constInterpolatorService.interpolate(CONSTANTS.NLP_SUCCEED);
      this.TRENDS_MAX_SELECTION = this.constInterpolatorService.interpolate(CONSTANTS.TRENDS_MAX_SELECTION);
      this.CANNOT_GET_TREATMENT_PLANS = this.translateService.instant(CONSTANTS.CANNOT_GET_TREATMENT_PLANS);
      this.EXCEEDS_ACR_EXPORT_LIMIT = this.translateService.instant(CONSTANTS.EXCEEDS_ACR_EXPORT_LIMIT);
      this.SUCCESSFULLY_MOVED_BACK_TO_WETLAB = this.translateService.instant(CONSTANTS.SUCCESSFULLY_MOVED_BACK_TO_WETLAB);
      this.TEST_SUCCESSFULLY_ABORTED = this.translateService.instant(CONSTANTS.TEST_SUCCESSFULLY_ABORTED);
      this.FILENAME_CONTAINS_HTML = this.translateService.instant(CONSTANTS.FILENAME_CONTAINS_HTML);
      this.TAG_CONTAINS_HTML = this.translateService.instant(CONSTANTS.TAG_CONTAINS_HTML);
      this.ACR_EXPORT_LIMIT_MSG = this.translateService.instant(CONSTANTS.ACR_EXPORT_LIMIT_MSG);
      this.FILE_TYPE_NOT_ALLOWED = this.translateService.instant(CONSTANTS.FILE_TYPE_NOT_ALLOWED);
      this.FAILED_TO_CLEAR_CACHE = this.translateService.instant(CONSTANTS.FAILED_TO_CLEAR_CACHE);
      this.CACHE_CLEARED_SUCCESSFULLY = this.translateService.instant(CONSTANTS.CACHE_CLEARED_SUCCESSFULLY);
    }

    Please_fill_required_fields: string;
    Patient_details_updated_successfully: string;
    Patient_details_saved_successfully: string;
    CLICK_ON_ADD_TO_THE_TABLE: string;
    UNABLE_TO_UPDATE_PATIENT_DETAILS: string;
    THERE_WAS_ERROR_DURING_UPDATE: string;
    NO_MODIFIED_DATA_TO_UPDATE: string;
    FILE_DELETED_SUCCESSFULLY: string;
    CANNOT_UPLOAD_FILE: string;
    ORDER_CREATED_SUCCESSFULLY: string;
    FAILED_TO_CREATE_AN_ORDER: string;
    ORDER_DELETED_SUCCESSFULLY: string;
    FAILED_TO_DELETE_ORDER: string;
    FAILED_TO_UPDATE_ORDER: string;
    ORDER_DETAILS_SAVED_SUCCESSFULLY: string;
    FAILED_TO_SAVE_ORDER_DETAILS: string;
    DATA_SAVED_SUCCESSFULLY: string;
    UNABLE_TO_SAVE_DATA: string;
    RELOAD_OF_FORM_DEFINITIONS_TRIGGERED_SUCCESSFULLY: string;
    FAILED_TO_TRIGGER_RELOAD_OF_FORM_DEFINITIONS: string;
    PLEASE_ADD_A: string;
    CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION: string;
    NO_MODIFIED_DATA_FOR_STOP_WORKFLOW: string;
    STOP_WORKFLOW_SUCCESSFUL: string;
    ERROR_IN_STOP_WORKFLOW: string;
    NO_MODIFIED_DATA_FOR_MANAGING_FACILITY: string;
    UPDATE_MANAGING_FACILITY_SUCCESSFUL: string;
    ERROR_IN_UPDATE_MANAGING_FACILITY: string;
    UNABLE_TO_UPDATE_PATIENT: string;
    PATIENT_UPDATED_SUCCESSFULLY: string;
    PATIENT_CREATED_SUCCESSFULLY: string;
    CONTINUING_WITH_EXISTING_PATIENT: string;
    UNABLE_TO_CREATE_PATIENT: string;
    FAILED_TO_CREATE_EVENT: string;
    EVENT_DELETED_SUCCESSFULLY: string;
    FAILED_TO_DELETE_EVENT: string;
    EVENT_CREATED_SUCCESSFULLY: string;
    EVENT_APPROVED_SUCCESSFULLY: string;
    EVENT_DATA_UPDATED_SUCCESSFULLY: string;
    FAILED_TO_UPDATE_EVENT_DATA: string;
    COPIED_EVENT_DATA_TO_RESPECTIVE_SOURCE: string;
    FAILED_TO_COPY_EVENT_DATA_TO_RESPECTIVE_SOURCE: string;
    EVENT_SELECTED_SUCCESSFULLY: string;
    CANNOT_UPLOAD_FILE_SIZE_EXCEEDS: string;
    CANNOT_UPLOAD_FILE_MAXIMUM_THRESHOLD_REACHED: string;
    FILE_UPLOADED_AND_ATTACHED_SUCCESSFULLY: string;
    IS_MISSING_IN_CONFIGURATION: string;
    NO_ITEMS_TO_EXPORT: string;
    FAILED_TO_EXPORT_DATA_TO_EXCEL: string;
  ASYNC_EXPORT_DATA_TO_EXCEL_STARTED: string;
  ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL: string;
  ASYNC_FAILED_TO_EXPORT_DATA_TO_EXCEL_EXPIRED: string;
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_TITLE: string;
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BODY: string;
  ASYNC_EXPORT_DATA_TO_EXCEL_COMPLETED_BUTTON: string;
    SOMETHING_WENT_WRONG_WITH_API_CALL: string;
    NO_ITEMS_SELECTED_FROM_WORKLIST: string;
    ERROR_IN_CREATING_FILTER: string;
    UPDATED_SUCCESSFULLY: string;
    FAILED_TO_UPDATE: string;
    DELETED_SUCCESSFULLY: string;
    ERROR_DELETING: string;
    CREATED_SUCCESSFULLY: string;
    FAILURE_TO_CREATE: string;
    UNABLE_TO_GENERATE_DOCUMENT: string;
    UNABLE_TO_SEND_REPORT_TO_EMR: string;
    RESOURCE_NOT_FOUND: string;
    ERROR_WHILE_UPDATING: string;
    CREATED_NEW_TEST_SUCCESSFULLY: string;
    ADDENDUM_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR: string;
    FAILED_POSTING_ADDENDUM_REPORT_TO_EMR: string;
    FAILED_POSTING_FINAL_REPORT_TO_EMR: string;
    FINAL_REPORT_WAS_SCHEDULED_FOR_POSTING_TO_EMR: string;
    UNABLE_TO_SUBMIT_TEST: string;
    ERROR_WHILE_GETTING_DATA_FOR_PDF_FROM_SERVER: string;
    ERROR_WHILE_SEARCH_FOR_TEST_FROM_WORKLIST: string;
    SUCCESSFULLY_MOVED_TO_NEXT_STEP: string;
    UNABLE_TO_MOVE_TO_THE_NEXT_STEP: string;
    TEST_REMOVED_FROM_YOUR_WORKLIST_SUCCESSFULLY: string;
    ERROR_WHILE_REMOVING_TEST_FROM_WORKLIST: string;
    FAILED_TO_GENERATE_PDF_TEMPLATE_TO_PREVIEW: string;
    CANNOT_PREVIEW_TEMPLATE_WAS_NOT_LOADED_YET: string;
    CANNOT_PUBLISH_TEMPLATE_WAS_NOT_LOADED_YET: string;
    CANNOT_SAVE_AS_DRAFT_TEMPLATE_WAS_NOT_LOADED_YET: string;
    EDITED_REPORT_TEMPLATE_DATA_WAS_CANCELLED: string;
    SUCCESSFULLY_BACK_TO_PREVIOUS_STEP: string;
    ITEM_REVISED_SUCCESSFULLY: string;
    FAILED_BACK_TO_PREVIOUS_STEP: string;
    ITEM_REVISE_FAILED: string;
    PATHWAY_NO_TREATMENT_WAS_SELECTED: string;
    PATHWAY_NO_OTHER_REASON_EXTRA_DETAILS: string;
    PATHWAY_OFF_PATH_NO_REASONING: string;
    SUCCESSFULLY_REPORT_GENERATED: string;
    NOT_ABLE_TO_FIND_MRN: string;
    NOT_ABLE_TO_FIND_ACCESSION_NUMBER: string;
    NOT_ABLE_TO_FIND_TEST_NUMBER: string;
    NOT_ABLE_TO_FIND_APPLICATION_NAME: string;
    NOT_ABLE_TO_FIND_SOURCE_EVENT_INFORMATION: string;
    SERVER_URL_NOT_CONFIGURED: string;
    SOME_OF_FIELDS_ARE_INVALID: string;
    NO_FINDINGS_INFO: string;
    FILE_UPLOAD_FAILED: string;
    DEFAULT_FILTER_CANNOT_BE_CHANGED: string;
    ERROR_WHILE_GETTING_DATA_FROM_SERVER: string;
    NLP_RUNNING: string;
    NLP_FAILED: string;
    NLP_SUCCEED: string;
    TRENDS_MAX_SELECTION: string;
    CANNOT_GET_TREATMENT_PLANS: string;
    EXCEEDS_ACR_EXPORT_LIMIT: string;
    SUCCESSFULLY_MOVED_BACK_TO_WETLAB: string;
    TEST_SUCCESSFULLY_ABORTED: string;
    UNABLE_TO_CREATE_DUPLICATE_BIODESIX_ORDER: string;
    FILENAME_CONTAINS_HTML: string;
    TAG_CONTAINS_HTML: string;
    ACR_EXPORT_LIMIT_MSG: string;
    FILE_TYPE_NOT_ALLOWED: string;
    FAILED_TO_CLEAR_CACHE: string;
    CACHE_CLEARED_SUCCESSFULLY: string;
    PATHWAY_NO_COMMENT_WAS_SELECTED: string;
    PATHWAY_NO_OPTION_WAS_SELECTED;
  }

/* END - GEN-86667 -------*/
